// this is a radio component
// it include the radio button and label
// all the setting is passed in using props
// onChange function is in parent
import React from "react";

const RadioButtons = (props) => {
  // index key value i, j, k
  let i = 0;
  let j = 0;
  let k = 0;

  //let data = props.data;
  //const [data, setData] = useState(cleanupData(props.data));

  // this is what json data need to look like,
  // use cleanupData to check the object array for all the fields,
  // if label is empty, set to value
  // if selected is null or empty, set the false
  // let hics_yesno_radios = [
  //   { value: true, label: "Yes", selected: false },
  //   { value: false, label: "No", selected: false }
  // ];

/*  function cleanupData(ary) {

    // check if array is not empty, else return empty array
    if (Array.isArray(ary) && ary.length > 0) {
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].value == null || ary[i].value === undefined) {
          ary.splice(i, 1); // remove if if there is no value
        } else {
          // set label as value if empty
          if (ary[i].label == null || ary[i].label === undefined) {
            ary[i].label = ary[i].value.toString();
          }
          // set selected to false if not selected
          if (ary[i].selected == null || ary[i].selected === undefined) {
            ary[i].selected = false;
          }
        }
      }
      return ary; // return update array
    }
    return []; // return empty array if data is not object array
  }*/

  function justLog(e) {

  }

  // on change event, since it is radio button, it will always have to pick a value
  // event is fire from radio button, e.target.value will carry the value
  // update local value,
  // update parent data
  // sent data to onChange event in parent
  function defaultOnChange(e) {
    for (var i = 0; i < props.data.length; i++) {
      props.data[i].selected = false;
    }
    props.data[e.target.getAttribute("index")].selected = true;
    //setData(data);

    if (
      props.onChange !== undefined &&
      props.onChange !== null &&
      props.value !== undefined &&
      props.value !== null
    ) {
      props.value(e.target.value);
      props.onChange(e.target.value);
    }
  }

  // onblur, this can set value to enpty,
  // this event can fire from group
  // e.target.value may not have value
  // fine selected value from the local data
  // return value or empty string
  function defaultOnBlur(e) {
    if (
      props.onBlur !== undefined &&
      props.onBlur !== null &&
      props.value !== undefined &&
      props.value !== null
    ) {
      if (props.data.find((v) => v.selected === true) !== undefined) {
        let value = props.data.find((v) => v.selected === true).value;
  
        props.value(value);
        props.onBlur(value.toString());
      } else {
        props.value("");
        props.onBlur("");
      }
    }
  }

  // this will change the touched flag in parent for formik
  function defaultOnFocus(e) {

    if (props.onFocus !== undefined && props.onFocus !== null) {
      props.onFocus(true);
    }
  }

  return (
    <div className="inputbox__container">
      <label
        className={`inputbox__label ${
          props.isDisabled ? "inputbox__label--disabled" : ""
        }
      ${props.hasError ? "inputbox__label--error" : ""}     
`}
        style={{
          display:
            props.label === undefined ||
            props.label === null ||
            props.label.length === 0
              ? "none"
              : "block"
        }}
      >
        {props.label}
        <span
          className={`inputbox__required  ${
            props.isRequired
              ? "inputbox__required--show"
              : "inputbox__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
      <div
        className={` ${
          props.layoutVertical ? "container--vertical" : "container--horizontal"
        } `}
        onChange={(e) => defaultOnChange(e)}
        onBlur={(e) => defaultOnBlur(e)}
        onFocus={(e) => defaultOnFocus(e)}
      >
        {props.data.map((item, index) => (
          <div className="radio__item" key={k++}>
            {/* radio button, value=1, group=gender, onChange even = setAnswer */}
            <input
              className="radio__button"
              type="radio"
              id={props.id + "_item_" + i++}
              name={props.name}
              value={item.value}
              checked={item.selected}
              index={index}
              onChange={(e) => justLog(e)}
            />
            <label htmlFor={props.id + "_item_" + j++} className="radio__label">
              <span>{item.label}</span>
            </label>
          </div>
        ))}
      </div>
      <span className="inputbox__help">{props.helpMessage}</span>
    </div>
  );
};

export default RadioButtons;
